// extracted by mini-css-extract-plugin
export var black = "_y-6";
export var brand = "_y-1";
export var ddefault = "_y-0";
export var error = "_y-3";
export var gray = "_y-2";
export var highContrast = "_y-8";
export var outline = "_y-7";
export var success = "_y-5";
export var warning = "_y-4";